import { ref } from 'vue';

import { useScrollLock } from './use-scroll-lock';

const isSizeChartOpen = ref(false);
const { lockScroll, unlockScroll } = useScrollLock();

export function useSizeChart() {
  const openSizeChart = () => {
    isSizeChartOpen.value = true;
    lockScroll();
  };

  const closeSizeChart = () => {
    isSizeChartOpen.value = false;
    unlockScroll();
  };

  return {
    closeSizeChart,
    isSizeChartOpen,
    openSizeChart,
  };
}
